const transformProducts = () => {
    if ($('.products .product').length) {
        const products = $('.products .product')

        if (products.length) {
            products.each(function () {
                const product = $(this)

                if (!product.hasClass('set-product')) {
                    product.find('.prices').addClass('ready')
                }
            })
        }
    }
}

export function initProducts() {
    transformProducts()
    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
        transformProducts()
    })
}
